<template>
	<div class="introduce">
		<div class="head-box" :style="`background-image: url(${core_title_image});`">
			<!-- <div class="head-box"> -->
			<!-- <div class="head_cont">
        <h5>关于我们</h5>
        <p>照明</p>
      </div> -->
		</div>

		<!-- 核心团队 -->
		<div class="team-box wow animate__animated animate__fadeInUp" style="z-index: 2">
			<div class="round-img-shelf">
				<img class="round-img-more-1" src="../assets/imgs/qiu1@2x.png" alt="" />
			</div>

			<div class="team-title-box">
				<span></span>
				<h5 class="headline">{{ core_team_title.name }}</h5>
				<p class="small_caption">{{ core_team_title.vice_name }}</p>
			</div>
			<div class="team-list-box">
				<div
					class="team-members-box"
					v-for="(item, index) in coreTeamData.content"
					:key="index"
					:style="'background-image: url(' + item.image + ')'"
				>
					<div class="members-infor">
						<h5>{{ item.name }}</h5>
						<p>{{ item.vice_name }}</p>
					</div>
				</div>
				<div
					v-for="(item, index) in coreTeamData.big_image"
					:key="index"
					class="team-boss-box"
					:style="'background-image: url(' + item.image + ')'"
				>
					<div class="boss-infor">
						<h5>{{ item.name }}</h5>
						<p>{{ item.vice_name }}</p>
					</div>
				</div>
				<!-- <div
          class="team-boss-box"
          :style="'background-image: url(' + baImgList[0] + ')'"
        >
          <div class="boss-infor">
            <h5>你好3</h5>
            <p>高级照明设计师</p>
          </div>
        </div> -->
			</div>
		</div>

		<div class="bj_box">
			<!-- 背景 -->
			<div class="box_img">
				<img src="../assets/imgs/lcbj.png" alt="" />
			</div>
			<!-- 服务内容 -->
			<div class="service-box wow animate__animated animate__fadeInUp">
				<div class="service-img-shelf">
					<img class="service-img-more-1" src="../assets/imgs/2.png" alt="" />
				</div>
				<div class="team-title-box">
					<span></span>
					<h5 class="headline">{{ ser_con_title.name }}</h5>
					<p class="small_caption">{{ ser_con_title.vice_name }}</p>
				</div>
				<div class="service-list-box">
					<div
						class="service-list"
						v-for="(item, index) in serviceContentData.content"
						:key="index"
					>
						<h5>{{ item.name }}</h5>
						<span></span>
						<p>
							{{ item.vice_name }}
						</p>
					</div>
				</div>
			</div>

			<!-- 服务流程 -->
			<div class="process-box wow animate__animated animate__fadeInUp">
				<div class="team-title-box">
					<span></span>
					<h5 class="headline">{{ ser_pro_title.name }}</h5>
					<p class="small_caption">{{ ser_pro_title.vice_name }}</p>
				</div>
				<div class="process-cont-box">
					<div class="process-intro-box">
						<span></span>
						<p>完善的服务流程</p>
						<p>推动项目科学落地</p>
					</div>
					<div class="process-list-box">
						<el-steps :active="processIndex == 0 || processIndex > 0 ? processIndex : null">
							<el-step
								v-for="(item, index) in serviceProData.content"
								:key="index"
								:title="item.name"
								@mouseover.native="mouseoverMaterialShare(index + 1)"
								@mouseout.native="processIndex = -1"
								:description="item.vice_name"
							></el-step>
							<!-- <el-step
                title="设计下单"
                @mouseover.native="mouseoverMaterialShare(1)"
                description="如您有照明设计或智能设计需求,均可发起设计下单"
              ></el-step>
              <el-step
                title="需求沟通"
                @mouseover.native="mouseoverMaterialShare(2)"
                description="订单下达后，将有专属设计师与您确认需求与报价"
              ></el-step>
              <el-step
                title="订单支付"
                @mouseover.native="mouseoverMaterialShare(3)"
                description="微信扫码轻松支付，提供开具发票入口"
              ></el-step>
              <el-step
                title="方案接收"
                @mouseover.native="mouseoverMaterialShare(4)"
                description="方案一键下载，快速推进项目落地进度"
              ></el-step> -->
						</el-steps>
					</div>
				</div>
			</div>
		</div>
		<div class="footer"></div>
	</div>
</template>

<script>
	/**
	 * $myGstTitle 核心团队接口
	 * $myGstContent 服务内容接口
	 * $myGstBottom 服务流程接口
	 */
	import { $myGstTitle, $myGstContent, $myGstBottom } from '../api/index';
	export default {
		data() {
			return {
				head_backgroundImage: {
					'background-image': 'url()',
				},
				processIndex: 0,
				baImgList: [require('../assets/imgs/wholeHouse.jpg')], //全部 书房等四张固定的背景图,

				coreTeamData: {}, // 核心团队
				core_team_title: {},

				serviceContentData: {}, // 服务内容
				ser_con_title: {}, // 服务内容

				serviceProData: {}, // 服务流程
				ser_pro_title: {}, // 服务流程

				core_title_image: null,
			};
		},
		beforeCreate() {},
		created() {
			this.coreTeam();
			this.serviceContent();
			this.serviceProcess();
			// console.log(this.head_backgroundImage);
		},
		beforeMount() {},
		mounted() {
			new this.$wow.WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 0,
				mobile: true,
				live: true,
			}).init();
		},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		components: {},
		methods: {
			// 服务流程
			mouseoverMaterialShare(index) {
				this.processIndex = index;
			},

			// 核心团队
			coreTeam() {
				$myGstTitle()
					.then((res) => {
						// console.log('核心团队', res);
						this.coreTeamData = res.data;
						this.core_team_title = res.data.title_name;
						this.core_title_image = res.data.title_image;
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 服务内容
			serviceContent() {
				$myGstContent()
					.then((res) => {
						// console.log('服务内容', res);
						this.serviceContentData = res.data;
						this.ser_con_title = res.data.title_name;
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 服务流程
			serviceProcess() {
				$myGstBottom()
					.then((res) => {
						// console.log('服务流程', res);
						this.serviceProData = res.data;
						this.ser_pro_title = res.data.title_name;
					})
					.catch((err) => {
						console.log(err);
					});
			},
		},
	};
</script>

<style lang="scss" scoped>
	* {
		box-sizing: border-box;
	}

	.introduce {
		position: relative;
		box-sizing: border-box;
		width: 100%;
		min-width: 1100px;
		min-height: 100vh;
		color: white;
		overflow: hidden;
	}

	.head-box {
		width: 100%;
		// background: url(../assets/imgs/banner.png);
		background-size: cover;
		background-repeat: no-repeat;
		height: calc(var(--proportion) * 1200px);
		margin-bottom: -100px;
	}

	.team-box {
		width: 100%;
		position: relative;
		// top: -260px;
		top: calc(var(--proportion) * -160px);
	}
	.round-img-shelf {
		position: absolute;
		// top: calc(var(--proportion) * -10px);
		top: calc(var(--proportion) * 100px);
		right: 0px;
		width: 65%;
		overflow: hidden;
		height: calc(var(--proportion) * 860px);
	}

	.round-img-more-1 {
		position: absolute;
		top: 0px;
		right: 0px;
		z-index: 0;
		transform: translateX(58%);
		width: calc(var(--proportion) * 1252px * 2.35);
		height: calc(var(--proportion) * 860px);
	}
	.bj_box {
		// ---
		position: relative;
		z-index: 100;
		// background: url(../assets/imgs/lcbj.png) no-repeat;
		// background-size: 100% auto;
		// background-position: bottom;

		.box_img {
			transform: scale(var(--proportion) / 2);
			position: absolute;
			z-index: 99;
			left: 0;
			bottom: -160px;
			width: 100%;
			img {
				width: 100%;
			}
		}
	}

	.team-title-box {
		// margin-top: 159px;
		text-align: center;
		position: relative;
		z-index: 100;

		span {
			display: none;
			width: 40px;
			height: 2px;
			background: #e60000;
			margin: 0 auto;
		}

		h5 {
			line-height: 1;
			font-size: 48px;

			// font-weight: bold;
			color: #ffffff;
			// line-height: 36px;
			opacity: 0.85;
			// margin: 32px 0 23px;
			white-space: pre-wrap;
		}

		p {
			font-size: 28px;

			font-weight: 500;
			color: #ffffff;
			line-height: 1;
			opacity: 0.5;
			white-space: pre-wrap;
		}
	}

	.team-list-box {
		position: relative;
		width: calc(var(--proportion) * 1920px);
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		padding: 0 calc(var(--proportion) * 50px);
		margin: 48px auto 0;
	}

	// 小图
	.team-members-box {
		position: relative;
		background-size: cover;
		background-repeat: no-repeat;
		overflow: hidden;
		width: calc(var(--proportion) * 240px * 0.9);
		height: calc(var(--proportion) * 318px * 0.9);
		margin: calc(var(--proportion) * 10px * 0.9);
	}

	.members-infor {
		position: absolute;
		width: 100%;
		bottom: 0;
		padding: 20px 24px;
		// padding-bottom: 20px;

		overflow: hidden;
		background: linear-gradient(0deg, #161515 0%, rgba(37, 37, 37, 0) 100%);

		h5 {
			font-size: 20px;

			// font-weight: bold;
			color: #ffffff;
			line-height: 20px;
			white-space: pre-wrap;
			margin-bottom: 12px;
			opacity: 0.85;
		}

		p {
			opacity: 0.5;
			font-size: 14px;

			font-weight: 400;
			color: #ffffff;
			line-height: 14px;
			white-space: pre-wrap;
		}
	}

	.team-members-box:nth-child(4),
	.team-members-box:nth-child(7),
	.team-members-box:nth-child(6),
	.team-members-box:nth-child(9) {
		margin-right: calc(var(--proportion) * 530px * 0.9);
	}

	// 大图
	.team-boss-box {
		position: relative;
		background-size: cover;
		background-repeat: no-repeat;

		width: calc(var(--proportion) * 500px * 0.9);
		height: calc(var(--proportion) * 656px * 0.9);
	}
	// 大图1
	.team-boss-box:nth-child(14) {
		position: absolute;
		top: calc(var(--proportion) * 10px);
		left: calc(var(--proportion) * 1100px * 0.987);
	}
	// 大图2
	.team-boss-box:nth-child(15) {
		position: absolute;
		top: calc(var(--proportion) * 347px * 0.9 + 1.5px);
		left: calc(var(--proportion) * 320px * 1.2);
	}

	.boss-infor {
		width: 100%;
		position: absolute;
		overflow: hidden;
		bottom: 0;
		padding: 20px 18px 24px 25px;
		background: #e60000;

		h5 {
			font-size: 24px;
			line-height: 24px;

			// font-weight: bold;
			color: #ffffff;
			white-space: pre-wrap;
			margin-bottom: 12px;
		}

		p {
			opacity: 0.7;
			font-size: 20px;

			font-weight: 400;
			color: #ffffff;
			line-height: 30px;
			white-space: pre-wrap;
			margin-bottom: -6px;
		}
	}

	.service-box {
		position: relative;
		z-index: 100;
		margin-top: -150px;
	}
	.process-box {
		position: relative;
		z-index: 100;
		// margin-top: 120px;
	}
	.service-img-more-1 {
		position: absolute;
		top: calc(var(--proportion) * 100px);
		right: 0px;
		width: 65%;
		overflow: hidden;
		height: calc(var(--proportion) * 800px);
	}
	.service-img-more-1 {
		position: absolute;
		// top: calc(var(--proportion) * -255px);
		top: calc(var(--proportion) * -155px);
		left: 0px;
		z-index: 0;
		transform: translateX(0%);
		width: calc(var(--proportion) * 542px);
		height: calc(var(--proportion) * 800px);
	}
	.service-list-box {
		display: flex;
		justify-content: center;
		// align-items: center; // ---
		margin-top: 48px;
		position: relative;
		z-index: 100;
	}
	.service-list {
		margin: 0 12.5px;
		width: calc(var(--proportion) * 340px);
		// height: calc(var(--proportion) * 422px);
		text-align: center;
		padding: 65px 40px;
		// background: rgb(37, 37, 37, .7);
		background: #252525;
		background: url('../assets/imgs/kapian.png') no-repeat;
		background-size: 100% 100%;
		z-index: 1;
		h5 {
			font-size: 24px;

			// font-weight: bold;
			color: #ffffff;
			line-height: 30px;
			opacity: 0.85;
		}
		span {
			display: block;
			width: 32px;
			height: 4px;
			background: #e60000;
			margin: 31px auto 48px auto;
		}
		p {
			font-size: 18px;
			margin-top: calc(var(--proportion) * -8px);

			font-weight: 400;
			color: #ffffff;
			opacity: 0.5;
			line-height: 36px;
		}
	}
	.process-cont-box {
		display: flex;
		align-items: center;
		justify-content: center; // ---
		width: calc(var(--proportion) * 1330px);
		margin: 91px auto 0;
	}
	.process-intro-box {
		width: 282px;
		min-width: 270px; // ---
		height: 260px;
		background: #e60000;
		padding: 64px 31px 0;
		span {
			display: block;
			width: 20px;
			height: 2px;
			background: #ffffff;
			margin-bottom: 45px;
		}
		p {
			font-size: 24px;

			font-weight: 500;
			color: #ffffff;
			line-height: 48px;
		}
	}
	.process-list-box {
		width: calc(var(--proportion) * 1056px);
		min-width: 834px; // ---
		height: calc(var(--proportion) * 260px);
		background: url(../assets/imgs/lcbj.png);
		background-size: cover;
		background-repeat: no-repeat;
		display: flex;
		align-items: center;
	}

	::v-deep .el-steps {
		margin-left: 80px;
		.el-step {
			cursor: pointer;
		}
		.el-step__line {
			top: 24px;
		}
		.el-step__icon {
			width: 48px;
			height: 48px;
			font-size: 24px;

			// font-weight: bold;
			border: none;
		}
		.el-step__main {
			color: #ffffff;
			.el-step__title {
				font-size: 20px;
				line-height: 1;

				// font-weight: bold;
				color: #ffffff;
				// line-height: 36px;
				margin: 34px 0 24px;
				opacity: 0.85;
			}
			.el-step__description {
				font-size: 14px;

				font-weight: 400;
				color: rgba(255, 255, 255, 0.5);
				line-height: 26px;
				padding-right: 15%;
			}
		}
		.el-step__head {
			display: flex;
		}
		.is-finish {
			color: #ffffff;
			border-color: #e60000;
			.el-step__icon {
				background: #e60000;
				.el-step__icon-inner {
					color: #ffffff;
				}
			}
		}
		.el-step__icon-inner {
			color: #333333;
		}
		.is-process {
			font-weight: 400;
		}
	}
	.footer {
		position: relative;
		z-index: 101;
		width: calc(var(--proportion) * 1920px);
		height: calc(var(--proportion) * 232px);
		background: url(../assets/imgs/diqiu.png);
		background-size: cover;
		background-repeat: no-repeat;
	}
	.process-list-box {
		::v-deep .el-step__description {
			font-size: 16px !important;
		}
	}

	// 大字标题
	.headline {
		padding-top: calc(var(--proportion) * 148px);
		margin-bottom: calc(var(--proportion) * 48px) !important;
		font-size: 28px !important;
		font-weight: 600;
		letter-spacing: 4px;
	}
	// 小字副标题
	.small_caption {
		opacity: 0.7 !important;
		margin-bottom: calc(var(--proportion) * 92px) !important;
		font-weight: 'PingFang SC', Helvetica, 'Microsoft YaHei';
		// font-size: calc(var(--proportion) * 16px) !important;
		font-size: 15px !important;
		font-weight: 100 !important;
		line-height: 1 !important;
	}
	.mar-bottom {
		margin-bottom: calc(var(--proportion) * 48px) !important;
	}
</style>
